/**
 * RULES
 *  1. use uppercase
 *  2. use lowercase if end-point have sub routes
 */
export const REST_API = {
  CENTER: "account/center",
  CENTERLEDGER: "account/center/ledgers",
  LOGIN: 'auth/login_check',

  PRODUCT: "product",
  PRODUCT_STOCK_MATERIAL_TYPE: "product/stock-material/type",
  PRODUCTGROUP: "product/group",
  DELIVERYPARTNER: "sale/delivery-partner",
  DISCOUNT: "pos/discount",
  CUSTOMER: "customer",
  DRAWERPAYMENT: "pos/payment/report/dashboard",
  MEMBERSHIPLEVEL: "customer/membership-level",
  CUSTOMERGENDER: "customer/gender",
  CUSTOMERSOURCE: "customer/source",
  GROUP: "group",
  group: {
    GROUP_COMPANY: "GROUP_/company",
    GROUP_LOCATION: "GROUP_/company/location",
  },
  PAYMENTTYPE: "pos/payment/method/type",
  PAYMENTMIXTYPE: "pos/payment/method/mixed/type",
  PAYMENTMFSTYPE: "pos/payment/method/mfs/type",
  PAYMENTCARDTYPE: "pos/payment/method/card/type",
  LEDGER: "account/ledger",
  DEPOSITCASH: "pos/deposit-cash",
  DEPOSITCASHSTATUS: "pos/deposit-cash/status",
  DEPOSITCASHAPPROVED: "pos/deposit-cash/approve",
  DEPOSITCASHCANCELLED: "pos/deposit-cash/cancel",
  ORDER: "pos/order",
  ORDERAPPROVE: "pos/order/approve",
  ORDERSTATUS: "pos/order/status",
  ORDERVOID: "pos/order/void",
  ORDERADDPRODUCT: "pos/order/add-product",
  ORDERUPDATEPRODUCT: "pos/order/update-product",
  ORDERREMOVEPRODUCT: "pos/order/remove-product",
  ORDERPRODUCTLIST: "pos/order/product-list",
  PAYMENT: "pos/payment",
  INVENTORY: "inventory/transaction/stock/loss-gain",
  INVENTORYSUBMIT: "inventory/transaction/stock/loss-gain/submit",
  INVENTORYAPPROVED: "inventory/transaction/stock/loss-gain/approve",
  INVENTORYCANCEL: "inventory/transaction/stock/loss-gain/cancel",
  INVENTORYCATEGORY: "inventory/transaction/stock/loss-gain/category",
  ITEMISSUEPURPOSE: "inventory/transaction/stock/issue/purpose",
  INVENTORYTYPE: "inventory/transaction/stock/loss-gain/type",
  INVENTORYSTATUS: "inventory/transaction/stock/loss-gain/status",
  INVENTORYSTOCKREQUISTION: "inventory/transaction/stock/transfer/requisition",
  INVENTORYSTOCKREQUISTIONCURRENTSTOCK: "inventory/transaction/stock/transfer/requisition/current-stock",
  INVENTORYSTOCKREQUISTIONSUBMIT: "inventory/transaction/stock/transfer/requisition/submit",
  INVENTORYSTOCKREQUISTIONSTATUS: "inventory/transaction/stock/transfer/requisition/status",
  INVENTORYREPORT: "pos/inventory/report",
  INVENTORYREPORTPERPRODUCT: "pos/inventory/product-wise",
  CUSTOMORDER: "pos/custom-order",
  CUSTOMORDERAPPROVE: "pos/custom-order/approve",
  CUSTOMORDERCONVERT: "pos/custom-order/convert",
  CUSTOMERORDERSTATUS: "pos/custom-order/status",
  CUSTOMORDERCANCEL: "pos/custom-order/cancel",
  CUSTOMORDERPRODUCTTYPE: "pos/custom-order/product-type",
  CUSTOMORDERPRODUCTSPECIFICATION: "pos/custom-order/product-specification",
  CUSTOMORDERPAYMENTSTATUS: "pos/custom-order/payment-status",
  CUSTOMORDERVOID: "pos/custom-order/void",
  PRODUCTRECEIVEVIEW: "inventory/transaction/stock/transfer",
  PRODUCTRECEIVESUBMIT: "inventory/transaction/stock/transfer/submit",
  PRODUCTRECEIVE: "inventory/transaction/stock/transfer/receive",
  PRODUCTRECEIVEAPPROVE: "inventory/transaction/stock/transfer/receive/approve",
  PRODUCTRECEIVERJECT: "inventory/transaction/stock/transfer/receive/reject",
  PRODUCTRECEIVESTATUS: "inventory/transaction/stock/transfer/status",

  PROMOTIONALITEMISSUE: "inventory/transaction/stock/issue",
  PROMOTIONALITEMISSUESUBMIT: "PROMOTIONALITEMISSUE_/submit",
  PROMOTIONALITEMISSUESTATUS: "PROMOTIONALITEMISSUE_/status",

  POSDAILYREDUCED: "REPORTSERVER-report/pos/reduced-sale",
  INVENTORYSUMMARYREPORT: "REPORTSERVER-report/inventory/summary",
};

export default REST_API;
